module.exports = __webpack_public_path__ + "static/media/bionow.2696c9e8.png";